module.exports = __webpack_public_path__ + "static/media/bis.e524cb2c.svg";